import React, { Component } from "react";
import Site from "./Site/Site";
import {
  Icon,
  Loader,
  Divider
} from "semantic-ui-react";
import SiteSearch from "../SiteSearch/SiteSearch";
import { Route } from "react-router-dom";
import "./CrawlErrors.css";

class CrawlErrors extends Component {
  state = {
    website: ""
  };

  handleChange = (e, { value }) => {
    this.props.history.push({
      pathname: `${this.props.match.path}/${value}`,
      state: { website: value }
    });
  };

  render() {
    let view = (
      <div className="NoData">
        <h2>
          Please select a website to continue{" "}
          <Icon name="hand pointer outline" />
        </h2>
      </div>
    );
    if (this.props.isLoading) {
      view = <Loader size="large" content="Loading" active />;
    } else if (this.props.history.location.state !== undefined) {
      const selectedSite = this.props.allCrawlErrors.find(selectedSite => {
        return (
          selectedSite.siteName === this.props.history.location.state.website
        );
      });

      view = (
        <Route
          path={`${this.props.match.path}/${
            this.props.history.location.state.website
          }`}
          render={props => (
            <Site
              {...props}
              crawlErrors={selectedSite.data}
              errorMessage={selectedSite.error}
              website={this.props.history.location.state.website}
              token={this.props.token}
            />
          )}
        />
      );
    }

    return (
      <div className="CrawlErrorsMain">
        <SiteSearch sites={this.props.sites} handleChange={this.handleChange} />
        <Divider />
        {view}
      </div>
    );
  }
}

export default CrawlErrors;



// WEBPACK FOOTER //
// ./src/components/CrawlErrors/CrawlErrors.js